/**
 * Rutas de la aplicacion.
 *
 * Las URL publicas son legibles a proposito —`/producto/broca-punta-centradora`
 * y no `/p/5896`— porque es parte de lo comprometido para SEO (`SEO-01`): el
 * resultado de Google tiene que inspirar confianza antes de que alguien haga
 * clic. Los patrones viven en `utilidades/rutas.ts`, no escritos a mano aca.
 *
 * Hay tres armazones, no dos: la tienda lleva cabecera y pie; el backoffice,
 * barra lateral; y el acceso —entrar y elegir clave— no lleva ninguno de los
 * dos, porque quien esta ahi todavia no tiene panel que enmarcar.
 */
import { Route, Routes } from 'react-router-dom';

import { DisenoAdmin } from './componentes/administracion/DisenoAdmin';
import { DisenoTienda } from './componentes/diseno/DisenoTienda';
import { Busqueda } from './paginas/Busqueda';
import { Carro } from './paginas/Carro';
import { Categoria } from './paginas/Categoria';
import { Checkout } from './paginas/Checkout';
import { ConfirmacionPedido } from './paginas/ConfirmacionPedido';
import { FichaProducto } from './paginas/FichaProducto';
import { Inicio } from './paginas/Inicio';
import { Linea } from './paginas/Linea';
import { NoEncontrado } from './paginas/NoEncontrado';
import { NuestraTienda } from './paginas/NuestraTienda';
import { Privacidad } from './paginas/Privacidad';
import { Terminos } from './paginas/Terminos';
import { Acceso } from './paginas/administracion/Acceso';
import { Administradores } from './paginas/administracion/Administradores';
import { AvisosVenta } from './paginas/administracion/AvisosVenta';
import { Busquedas } from './paginas/administracion/Busquedas';
import { CambiarClave } from './paginas/administracion/CambiarClave';
import { Despacho } from './paginas/administracion/Despacho';
import { Panel } from './paginas/administracion/Panel';
import { Pedidos } from './paginas/administracion/Pedidos';
import { Portada } from './paginas/administracion/Portada';
import { ProductoDetalle } from './paginas/administracion/ProductoDetalle';
import { Productos } from './paginas/administracion/Productos';
import { Random } from './paginas/administracion/Random';
import { RecuperarClave } from './paginas/administracion/RecuperarClave';
import { RestablecerClave } from './paginas/administracion/RestablecerClave';

export function Enrutador() {
  return (
    <Routes>
      <Route element={<DisenoTienda />}>
        <Route path="/" element={<Inicio />} />
        <Route path="/linea/:slug" element={<Linea />} />
        <Route path="/categoria/:slug" element={<Categoria />} />
        <Route path="/producto/:slug" element={<FichaProducto />} />
        <Route path="/buscar" element={<Busqueda />} />
        <Route path="/carro" element={<Carro />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/confirmacion" element={<ConfirmacionPedido />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/nuestra-tienda" element={<NuestraTienda />} />
        <Route path="*" element={<NoEncontrado />} />
      </Route>

      {/* Fuera del armazon del panel: se ven sin sesion, o con la clave temporal. */}
      <Route path="/admin/acceso" element={<Acceso />} />
      <Route path="/admin/clave" element={<CambiarClave />} />
      <Route path="/admin/recuperar" element={<RecuperarClave />} />
      <Route path="/admin/restablecer" element={<RestablecerClave />} />

      <Route path="/admin" element={<DisenoAdmin />}>
        <Route index element={<Panel />} />
        <Route path="portada" element={<Portada />} />
        <Route path="productos" element={<Productos />} />
        <Route path="productos/:id" element={<ProductoDetalle />} />
        <Route path="pedidos" element={<Pedidos />} />
        <Route path="despacho" element={<Despacho />} />
        <Route path="avisos-compra" element={<AvisosVenta />} />
        <Route path="busquedas" element={<Busquedas />} />
        <Route path="random" element={<Random />} />
        <Route path="administradores" element={<Administradores />} />
      </Route>
    </Routes>
  );
}
